<template>
  <div class="grid grid-cols-2 gap-6">
    <div class="rounded-md bg-ontick-graphite-500 px-6 py-6">
      <h2 class="text-lg text-gray-300">Participação por ativo</h2>
      <v-chart autoresize :option="chartPie(chart)"></v-chart>
    </div>
    <div class="rounded-md bg-ontick-graphite-500 px-6 py-6">
      <div class="overflow-x-auto">
        <div class="py-2">
          <div class="overflow-hidden rounded-lg shadow">
            <table class="min-w-full divide-y divide-ontick-steel-500">
              <thead class="bg-ontick-steel-500">
                <tr>
                  <th
                    v-for="(item, index) in header"
                    :key="index"
                    class="px-6 py-3 text-sm font-bold leading-4 text-gray-200"
                  >
                    {{ item }}
                  </th>

                  <th class="px-6 py-3"></th>
                </tr>
              </thead>
              <tbody
                class="divide-y divide-ontick-steel-500 bg-ontick-graphite-500"
              >
                <tr
                  class="space-y-2 text-center"
                  :class="
                    item.license_status == 'ATIVA'
                      ? 'text-gray-300'
                      : 'text-gray-500'
                  "
                  v-for="(item, index) in data"
                  :key="index"
                >
                  <td class="whitespace-no-wrap px-4 py-2 text-sm">
                    #{{ item.license_id }}
                  </td>

                  <td class="whitespace-no-wrap px-4 py-2 text-sm">
                    {{ item.product_name }}
                  </td>

                  <td class="whitespace-no-wrap px-4 py-2 text-sm">
                    {{ item.license_status }}
                  </td>
                  <td class="whitespace-no-wrap px-4 py-2 text-sm">
                    {{ item.license_create_date }}
                  </td>
                  <td class="whitespace-no-wrap px-4 py-2 text-sm">
                    <span v-show="item.license_next_charge != '-'">{{
                      item.license_next_charge
                    }}</span>

                    <span v-show="item.license_next_charge == '-'"> -</span>
                  </td>

                  <td
                    v-show="item.license_price == 0"
                    class="whitespace-no-wrap px-4 py-2 text-sm font-medium leading-5"
                  >
                    Grátis
                  </td>

                  <td
                    v-show="item.license_price != 0"
                    class="whitespace-no-wrap px-4 py-2 text-sm font-medium leading-5"
                  >
                    {{ item.license_price | currency }}
                  </td>

                  <td class="px-4 py-2 font-medium leading-5">
                    <button
                      class="text-sm text-ontick-blue-600"
                      @click="subscriptionAction(item)"
                    >
                      {{ item.action }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import VChart from "vue-echarts";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { PieChart } from "echarts/charts";
import { GridComponent, DatasetComponent } from "echarts/components";
use([CanvasRenderer, PieChart, GridComponent, DatasetComponent]);

export default {
  components: {
    VChart,
  },
  props: {
    chart: { type: Array, type: Object },
    item: { type: Array },
  },
  computed: {
    ...mapState({
      color: (state) => state.investment.color,
    }),
  },

  methods: {
    chartPie(value) {
      let color = this.color;
      let option = {
        dataset: {
          dimensions: ["fin_volume", "strategy_symbol"],
          source: value,
        },

        grid: {
          top: "5%",
          bottom: "5%",
          left: "0",
          right: "0",
          containLabel: false,
        },
        series: [
          {
            type: "pie",
            radius: ["60%", "100%"],
            selectedMode: "single",
            selectedOffset: 3,
            // clockwise: true,
            itemStyle: {
              borderRadius: 5,
              borderColor: "#202A37",
              borderWidth: 2,
              color: function (value) {
                return color[value.dataIndex];
              },
            },

            label: {
              show: false,
              position: "center",
            },

            emphasis: {
              label: {
                show: true,
                fontSize: "12",
                fontWeight: "normal",
                textBorderColor: "#fff",
                padding: [3, 8],
                borderRadius: 10,
                formatter: function (value) {
                  return `{a|${value.data.strategy_name}}\n{hr|}\n {b|${value.data.strategy_symbol}}  {per|${value.percent}%}`;
                },
                backgroundColor: "rgba(23, 30, 39, 0.9)",
                borderColor: "rgba(23, 30, 39, 1)",
                borderWidth: 0,

                color: "#fff",
                rich: {
                  a: {
                    color: "#fff",
                    lineHeight: 28,
                    align: "center",
                  },
                  hr: {
                    borderColor: "#8C8D8E",
                    width: "100%",
                    borderWidth: 0,
                    height: 0,
                  },
                  b: {
                    color: "#fff",
                    fontSize: 12,
                    fontWeight: "bold",
                    lineHeight: 33,
                  },
                  per: {
                    color: "#fff",
                    backgroundColor: "#0694e6",
                    padding: [3, 4],
                    borderRadius: 4,
                  },
                },
              },
            },
            labelLine: {
              show: true,
            },
          },
        ],
      };
      return option;
    },
  },
};
</script>

<style></style>
